export const ACTION_AUTH_SIGNUP_SUCCESS = '@action/AUTH/SIGNUP_SUCCESS'

export const REQUEST_RESET_PASSWORD_SUCCESS =
  'We have sent you an email with your password reset link. Please contact us if you do not receive it within a few minutes.'
export const RESET_PASSWORD_SUCCESS = 'New password set successfully. Login now using your email and new password.'

export const ERROR_GET_AUTH_SERVER = 'Authentication failed. Please try logging in again.'
export const ERROR_GET_AUTH_CLIENT = 'Invalid credentials. Please try again.'
export const ERROR_AUTH_SIGNUP = 'We could not process your request for signing up. Please try again later.'
export const SUCCESS_AUTH_SIGNUP =
  'Your account has been successfully created. Please login to start using our platform.'
export const ERROR_AUTH_SIGNUP_CAPTCHA =
  'Google captcha thinks you might be a bot. Please turn off any adblockers and try again (or try in a browser without any extensions installed). If the problem persists, please reach out for help.'
export const ERROR_AUTH_SIGNUP_EMAIL_FAILURE = 'The email address is already registered.'
export const ERROR_RESET_PASSWORD_FAILURE =
  'Resetting password failed. Please try again. If the problem persists, please reach out for help.'
export const ERROR_REQUEST_RESET_PASSWORD_FAILURE =
  'Resetting password request failed. Please try again. If the problem persists, please reach out for help.'
export const ERROR_SERVER_AUTH_SIGNUP_EMAIL = 'We could not verify your details. Please try again.'
export const ERROR_AUTH_LOAD_VERIFY = 'Could not load captcha verification library. Please try again later.'
export const ERROR_AUTH_VERIFY_OTP = 'Two-factor authentication failed. Please check your code or try again later.'
export const ERROR_AUTH_VERIFY_RECOVERY_CODE =
  'Recovery code authentication failed. Please check your code or try again later.'
export const ERROR_SET_TRIAL_MODE = 'Error setting trial mode. Please try again later.'
export const ERROR_CHECK_INVITATION = 'Error verifying your invitation. Please try again later.'
export const ERROR_ACCEPT_INVITATION = 'Error accepting your invitation. Please try again later.'
export const ERROR_ACCEPT_INVITATION_WITH_SIGNUP =
  'Error singing up and accepting your invitation. Please try again later.'

export const SIGNUP_ERROR_MAP: Record<string, string> = {
  'no captcha token provided': ERROR_AUTH_SIGNUP_CAPTCHA,
  'captcha token invalid': ERROR_AUTH_SIGNUP_CAPTCHA,
}
